import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileList } from 'modules/candidate-profile/components/CandidateProfileList';
import { VisibleTalentListGate } from 'modules/candidate-profile/components/VisibleTalentListGate';
import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';

export const AnalyseTalentPoolDetails: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { candidateBatchId, talentPoolId } =
    getPathParams.ANALYSE_TALENT_POOL_DETAILS();
  const props: CandidateProfileListProps = {
    type: CandidateProfileListType.ANALYSIS_CANDIDATES_FROM_TALENT_POOL,
    candidateBatchId,
    talentPoolId
  };

  return (
    <VisibleTalentListGate
      talentPoolId={talentPoolId}
      candidateProfileListProps={props}
    >
      <CandidateProfileList {...props} />
    </VisibleTalentListGate>
  );
};
